import { type FilterStatus, TransactionsHeader } from './TransactionsHeader'
import { TransactionsTable } from './TransactionsTable'
import { type PageInfo } from '../ui'
import {
  type TransactionType,
  type TransactionStatus,
  type DepositStatus,
  type SwapStatus,
} from '../../types/transactions'

export interface TransactionData {
  id: string
  group: string
  company: string
  user?: string | null
  type: TransactionType
  status: TransactionStatus
  depositStatus?: DepositStatus | null
  swapStatus?: SwapStatus | null
  groupBps?: number | null
  swapGroupBps?: number | null
  swapLpBps?: number | null
  swapValiantBps?: number | null
  lpId: number
  isFlagged: boolean
  isExternalApi?: boolean | null
  transaction: {
    from?: string | null
    fromCurrency?: string | null
    to?: string | null
    toCurrency?: string | null
    amount?: string | null
    currency?: string | null
    fromCurrencyImage?: string | null
    toCurrencyImage?: string | null
    fromNetwork?: string | null
    toNetwork?: string | null
  }
  createdDate?: string | null
  approvedDate?: string | null
  finalizedDate?: string | null
}

export interface TransactionsTabViewProps {
  transactions: TransactionData[]
  loading?: boolean
  // searchInput: string
  selectedStatus: string | null
  selectedType: string | null
  isFlagged?: boolean | null
  // onSearchChange: (search: string) => void
  onFilter: (
    status: FilterStatus | null,
    type: TransactionType | null,
    flagged?: boolean | null,
  ) => void
  onApproveTransaction?: (transactionId: string) => void
  onRejectTransaction?: (transactionId: string) => void
  onViewTransactionDetails?: (transactionId: string, type: string) => void
  onExportCSV?: () => void
  onRefresh?: () => void
  isRefreshing?: boolean
  showExportButton?: boolean
  showRefreshButton?: boolean
  showActionButtons?: boolean
  showFlagColumn?: boolean
  hideDepositActions?: boolean
  hideGroupColumn?: boolean
  // Pagination props
  pageInfo?: PageInfo
  totalCount?: number
  onNextPage?: (cursor: string) => void
  onPreviousPage?: (cursor: string) => void
  showPagination?: boolean
  headerSearchInput?: React.ReactNode
}

export function TransactionsTabView({
  transactions,
  loading = false,
  // searchInput,
  selectedStatus,
  selectedType,
  isFlagged,
  // onSearchChange,
  onFilter,
  onApproveTransaction,
  onRejectTransaction,
  onViewTransactionDetails,
  onExportCSV,
  onRefresh,
  isRefreshing = false,
  showExportButton = false,
  showRefreshButton = false,
  showActionButtons = false,
  showFlagColumn = false,
  hideDepositActions = false,
  hideGroupColumn = false,
  // Pagination props
  pageInfo,
  totalCount = 0,
  onNextPage,
  onPreviousPage,
  showPagination = false,
  headerSearchInput,
}: TransactionsTabViewProps) {
  return (
    <div className="space-y-4">
      <TransactionsHeader
        selectedStatus={selectedStatus as TransactionStatus}
        selectedType={selectedType as TransactionType}
        isFlagged={isFlagged}
        onFilter={onFilter}
        onExportCSV={onExportCSV}
        onRefresh={onRefresh}
        isRefreshing={isRefreshing}
        showExportButton={showExportButton}
        showRefreshButton={showRefreshButton}
        headerSearchInput={headerSearchInput}
      />

      <TransactionsTable
        transactions={transactions}
        loading={loading}
        onApproveTransaction={onApproveTransaction}
        onRejectTransaction={onRejectTransaction}
        onViewTransactionDetails={onViewTransactionDetails}
        showActionButtons={showActionButtons}
        showFlagColumn={showFlagColumn}
        pageInfo={pageInfo}
        totalCount={totalCount}
        onNextPage={onNextPage}
        onPreviousPage={onPreviousPage}
        showPagination={showPagination}
        hideDepositActions={hideDepositActions}
        hideGroupColumn={hideGroupColumn}
      />
    </div>
  )
}
